import filterNoDublicate from "./filterNoDublicate";
import getRedirectLink from "./getRedirectLink";
import initRegions from "./init-regions";

const shortForm = (OnlinePrograms, OfflinePrograms) => {
  const formBlock = document.getElementById("shortForm");

  if (!formBlock) {
    return;
  }

  try {
    if (OnlinePrograms.length > 0 || OfflinePrograms.length > 0) {
      const loader = document.querySelector(".monitoring__loader");

      loader.classList.remove("active");
      formBlock.style.display = "block";
    }
  } catch (e) {
    console.log(e);
  }

  const Regions = document.getElementById("shortFormRegions"),
    Program = document.getElementById("shortFormProgram"),
    link = document.getElementById("shortForm-link"),
    Format = document.getElementById("shortTrainingFormat"),
    City = document.getElementById("shortCity"),
    HiddenBlock = document.getElementById("hiddenBlockShortForm");

  let region = "",
    format = "",
    city = "",
    allPrograms = [],
    allProgramsRegionFiltred = [],
    filterNoDublicatePrograms = [],
    allProgramsFilter = [],
    filterPrograms = [];

  /* Список городов, доступный для данного региона */
  let cities = [];

  /* Событие на изменение поля Формат обучения */
  Format.onchange = function (e) {
    HiddenBlock.style.display = "block";
    format = e.target.value;
    $(`#shortFormRegions`).val(null).trigger("change");
    $(`#shortFormProgram`).val(null).trigger("change");

    let elementEmptyModal = document.querySelector(".form__field-regions");
    elementEmptyModal?.remove();
    allPrograms = [];

    if (format == "online") {
      allPrograms = OnlinePrograms;
      City.parentElement.style.display = "none";
      City.parentElement
        .querySelector(".city-required")
        .classList.remove("form-required");
      initRegions(OnlinePrograms, "online", "shortFormRegions");
    } else {
      allPrograms = OfflinePrograms;
      $(`#shortCity`).val(null).trigger("change");
      City.parentElement.style.display = "block";
      City.parentElement
        .querySelector(".city-required")
        .classList.add("form-required");
      initRegions(OfflinePrograms, "offline", "shortFormRegions");
    }
  };

  /* Событие на изменение поля Регионы */
  Regions.onchange = function (e) {
    region = e.target.value;

    /* Фильтрация общего массива в зависимости от выбранного региона */
    allProgramsRegionFiltred = allPrograms.filter((item) =>
      item.regions.some((it) => it.regionId == region)
    );

    /* Логика по отсеиванию программ с одинаковыми shortname, у которых нет в данном регионе редиректа */
    let programsDublicate = structuredClone(allProgramsRegionFiltred);

    filterNoDublicatePrograms = [];
    allProgramsFilter = [];
    allProgramsFilter = filterNoDublicate(programsDublicate);

    if (format == "online") {
      allProgramsFilter.forEach((item) => {
        item.regions.forEach((el) => {
          if (el.regionId == region && el.link) {
            item.Redirect = true;
          }
        });
      });

      filterNoDublicatePrograms = allProgramsFilter.filter(
        (item) => item.Redirect
      );

      logicFieldCategory();
      renderOptions(filterPrograms, "Program");   
    } else {
      cities = [];
      city = "";

      allProgramsFilter.forEach((i) => {
        i.regions.forEach((j) => {
          if (j.regionId == region && j.link) {
            i.Redirect = true;
            filterNoDublicatePrograms.push(i);
            j.cities.forEach((k) => {
              cities.push(k.city);
            });
          }
        });
      });

      cities = cities.filter((item, index) => cities.indexOf(item) === index);

      logicFieldCategory();
      renderOptions(filterPrograms, "City");
    }   
  };

  /* События на изменение поля Город */
  City.onchange = function (e) {
    link.classList.add("disabled");
    city = e.target.value;

    renderOptions(filterPrograms, "Program");
    logicFieldCategory();
    renderOptions(filterPrograms);      
  };

  /* Добавление ссылки на кнопку */
  Program.onchange = function (e) {
    if (region != "") {
      let redirect = getRedirectLink(filterNoDublicatePrograms, e, region);

      e.target.options[e.target.selectedIndex].setAttribute(
        "linkrvr",
        redirect
      );

      /* Добавляем ссылку на РВР в кнопку */
      link.classList.remove("disabled");
      link.href = redirect;
      link.addEventListener("click", () => {
        if (window.yaCounter94760218) {
          ym(94760218, "reachGoal", "form_short");
        }
      });
    }
  };

  /* Логика на поле Категории */
  function logicFieldCategory() {
    link.classList.add("disabled");
    filterPrograms = filterNoDublicatePrograms;

    if (region != "") {
      modalMissProgMain(
        Regions,
        filterPrograms,
        filterNoDublicatePrograms
      );
    }
  }

  /* Создаем нужные options */
  function renderOptions(arr, field) {
    if (field == "City") {
      [...City.children].map((item, idx) => {
        if (idx > 0) {
          item.remove();
        }
      });

      cities.forEach((item) => {
        let option = new Option(item, item, false, false);
        City.append(option);
      });
    } else {
      [...Program.children].map((item, idx) => {
        if (idx > 0) {
          item.remove();
        }
      });

      arr.forEach((item) => {
        let option = new Option(item.name, item.name, false, false);
        option.setAttribute("operator", item.operator);
        option.setAttribute("shortName", item.shortName);
        option.setAttribute("odinid", item.id);

        Program.append(option);
      });
    }
  }

  /* Модальное окно об отсутствии программ для Главной страницы */
  function modalMissProgMain(Regions, arr, arrAllProgramsRegions) {
    let elementEmptyModal = document.querySelector(".form__field-regions"),
      emptyModal =
        arrAllProgramsRegions.length == 0
          ? `<div class="form__field-regions"><div class="form__field-regions__block"><p>К сожалению, по данному региону нет доступных программ</p></div></div>`
          : `<div class="form__field-regions"><div class="form__field-regions__block"><p>К сожалению, по данному уровню образования нет доступных программ</p></div></div>`;

    elementEmptyModal?.remove();

    if (Regions.value == "") {
      return;
    }

    if (arr === undefined || arr.length == 0) {
      Regions.insertAdjacentHTML("afterend", emptyModal);
    } else {
      elementEmptyModal?.remove();
    }
  }
};

export default shortForm;
